import { Events } from 'src/constants/webSocketConsts/events';
import { ApiTags, appAPI } from 'src/services/api';
import { Refund } from 'src/services/api/refundsApi';
import { AppDispatch } from 'src/store/configureStore';

export function handleRefundUpdate(
  _event: Events,
  items: Refund[],
  dispatch: AppDispatch,
) {
  if (!items.length) {
    return;
  }

  // Refresh the refunds list and invoice queries so the UI reflects the new
  // refund status (eg pending → succeeded). Both lists/details on the dashboard
  // and on the invoice detail page rely on these tags.
  dispatch(
    appAPI.util.invalidateTags([
      { type: ApiTags.refunds },
      { type: ApiTags.invoices },
      { type: ApiTags.clientInvoices },
    ]),
  );
}
